export function footer() {
    (function() {
        /**
         * Footer Waves Background
         *
         * The footer wave graphic sits between the last page section and the
         * footer. Copy the background class (bgGray, bgLightblue, etc.) from
         * the last visible section onto .footer-waves so the area above the
         * wave matches the section it overlaps.
         */
        const $waves = $('.footer-waves');
        if (!$waves.length) return;

        const bgClassPattern = /^bg[A-Z]/;

        // Match the "last visible section" logic in ui.js so both agree on
        // which section is last, and fall back to any section on the page.
        let sections = [...document.querySelectorAll('main > section')];
        if (!sections.length) sections = [...document.querySelectorAll('section')];

        const lastVisible = sections.reverse().find(s => getComputedStyle(s).display !== 'none');
        if (!lastVisible) return;

        const bgClass = [...lastVisible.classList].find(cls => bgClassPattern.test(cls));
        if (!bgClass) return;

        // Clear any previously applied bg class before adding the new one
        $waves.each(function() {
            [...this.classList]
                .filter(cls => bgClassPattern.test(cls))
                .forEach(cls => this.classList.remove(cls));
            this.classList.add(bgClass);
        });
    })();
}
